import { NgModule } from '@angular/core';
import { TagsListComponent } from './tags-list.component';

@NgModule({
  imports: [TagsListComponent],
  exports: [TagsListComponent]
})
export class TagsListModule {}
